import script from "./Scrollable.vue?vue&type=script&setup=true&lang=js"
export * from "./Scrollable.vue?vue&type=script&setup=true&lang=js"

import "./Scrollable.vue?vue&type=style&index=0&id=d3c3177e&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3c3177e"]])

export default __exports__